const CONFIG = {
  KEY: '123',
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/small/',
  CACHE_NAME: 'DaftResto-V1',
  DATABASE_NAME: 'daftresto-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurant',
};

export default CONFIG;
